import { FC } from 'react';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import './index.less';

export const SearchBarSkeleton: FC = () => {
  return (
    <div className="searchBar">
      <Skeleton
        paragraph={false}
        title={{ style: { margin: '3px 0px 3px 11px', width: 80 } }}
      />
      <span className="searchBar__postfixIcon">
        <Skeleton.Avatar size={14.5} />
      </span>
    </div>
  );
};
